module.exports = __webpack_public_path__ + "static/media/computer-speaker.cad5b6e6.svg";